import { type IHeaderGroupParams } from "ag-grid-community";
import { type FC, useMemo, useRef } from "react";
import { AnimatedTooltip, HStack } from "widgets";
import { useTooltip } from "widgets/hooks";

import { CELL_EXPANSION } from "@/settings/settings.ts";
import { ExpansionIconCell } from "@/ui-modules/core/grid/cells/headers/ExpansionIconCell.tsx";

import { type ICustomColDef } from "../../DataTable.tsx";
import { type IGridContextProps } from "../../InMemoryTableWithSelectionModel.tsx";
import style from "./HeaderGroupCell.module.css";

export const HeaderGroupCell: FC<IHeaderGroupParams> = (props) => {
  const { displayName, columnGroup } = props;
  const context: IGridContextProps = props.context;

  const headerRef = useRef<HTMLDivElement | null>(null);
  const { state, triggerProps, tooltipProps } = useTooltip(headerRef, { delay: 500 });

  const expandableColumnGroupField = useMemo<string | undefined | null>(() => {
    if (!context?.tableSpec) {
      return null;
    }

    const firstExpandableColumn: ICustomColDef | undefined | null = columnGroup
      .getLeafColumns()
      .map((column) => column.getUserProvidedColDef() as ICustomColDef)
      .find((column: ICustomColDef | null) => column?.cellExpansion === CELL_EXPANSION.GROUP);

    return firstExpandableColumn?.groupField;
  }, [context?.tableSpec, columnGroup]);

  return (
    <>
      <HStack className={style.group_header}>
        <div className={style.group_header_title} ref={headerRef} {...triggerProps}>
          {displayName}
        </div>
        {expandableColumnGroupField && (
          <ExpansionIconCell tableQuerySpec={context!.tableSpec!} expandableField={expandableColumnGroupField} />
        )}
      </HStack>

      <AnimatedTooltip state={state} targetRef={headerRef} domProps={tooltipProps} nonInteractive>
        {displayName}
      </AnimatedTooltip>
    </>
  );
};
